
import { Contact } from "@/models/base";
import { Product } from "@/models/base";
import { ProductSupplier } from "@/utils/product-supplier";
import Vue from "vue";
import { SupplierService } from "../../services/supplier-service";
import AppLabel from "@/components/common/InfoInput.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { UserConfigService } from "@/services";
import { AuthService } from "@/services/auth-service";
import { CurrencyService } from "@/services/currency-service";
import Currency from "@/models/base/currency";

export default Vue.extend({
	data() {
		return {
			openedSeller: 0,
			supplierContact: null as Contact | null,
			percentage: 0,
			focus: "",
			isLoaded: false,
			DossierConfigService
		};
	},
	props: {
		product: Object as () => Product,
	},
	computed: {
		canSeeSellPrices():boolean{
			return UserConfigService.hasCurrentUserPermission(p=>p.CanReadProductPurchaseDetails);
		},
		isAllowedMultiValuta():boolean{
			return AuthService.hasModule(10);
		},
		currency():Currency | null {
			if (!this.supplier) return null;
			return CurrencyService.getCurrencies().find(c => c.ID == this.supplier!.CurrencyID) || null;
		},
		currencyPrefix():string {
			return this.currency?.Prefix || "";
		},
		sellerTabs(): string[] {
			return this.product.Suppliers.map((s, i) => {
				if (s.Contact?.ID){
					return s.Contact.getDisplayName();
				}
				return (this.$ct("labels.seller", {num: i + 1}).toString());
			});
		},
		supplier(): ProductSupplier | undefined {
			return this.product.Suppliers[this.openedSeller];
		},
		nettoPrice: {
			get(): number {
				return (this.supplier as ProductSupplier).NettoPrice || 0;
			},
			set(newValue: number) {
				(this.supplier as ProductSupplier).NettoPrice = newValue;
			}
		},
		catalogPrice: {
			get(): number {
				return (this.supplier as ProductSupplier).CatalogPrice || 0;
			},
			set(newValue: number) {
				(this.supplier as ProductSupplier).CatalogPrice = newValue;
			}
		},
		decimals():number{
			return this.DossierConfigService.getDecimalSettings().Buy;
		}
	},
	watch: {
		async supplier(newValue: ProductSupplier) {
			this.supplierContact = null;
			if (newValue.ContactID != 0) {
				this.supplierContact = await SupplierService.getContact(newValue.ContactID);
			} else {
				this.supplierContact = null;
			}
			this.computePercentage();
		},
		"supplier.ContactID": {
			immediate: true,
			async handler(contactID: number) {
				this.fetchContact();
			}
		}
	},
	methods: {
		computePercentage() {
			let nettoPrice = this.nettoPrice;
			let catalogPrice = this.catalogPrice;
			this.percentage = catalogPrice ? ((nettoPrice / catalogPrice) * 100 - 100) * -1 : 0;
		},
		computeNetto() {
			this.nettoPrice = this.catalogPrice * ((this.percentage + 100.0) / 100);
		},
		async fetchContact() {
			if (!this.supplier) return;
			if (this.supplier.ContactID == null || this.supplier.ContactID == 0) return;
			if (this.supplierContact && this.supplierContact.ID == this.supplier.ContactID) return;
			this.supplierContact = await SupplierService.getContact(this.supplier.ContactID);
		},
	},
	async mounted() {
		if (this.supplier) {
			this.computePercentage();
			//await this.fetchContact();
		}
		this.openedSeller =  this.product.Suppliers.findIndex(supplier => supplier.IsMainSupplier === true);
		if (this.openedSeller == -1){
			this.openedSeller = 0;
		}
		this.isLoaded = true;
	},
	components: {
		AppLabel
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
